var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'iconButton',
    {
      'iconButton--noBorder': _vm.noBorder,
      'iconButton--bigger': _vm.bigger,
      'iconButton--colored': _vm.colored,
      'iconButton--disabled': _vm.disabled,
      'iconButton--text': _vm.text,
    },
  ],attrs:{"to":_vm.to,"href":_vm.href,"type":_vm.tag === 'button' ? 'button' : '',"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.icon)?_c('span',{class:[`icon-${_vm.icon}`, 'iconButton__icon', { 'iconButton__icon--table': _vm.tableIcon }]}):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',{staticClass:"iconButton__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }